export default /* @ngInject */ class {

  //@ngInject
  constructor($mdDialog, config, userService) {
    this.dependencies = {
      $mdDialog: $mdDialog,
      config: config,
      userService: userService
    };
  }

  subscribe() {
    this.dependencies.userService.setBDN(true)
      .then(() => this.dependencies.$mdDialog.hide());
  }

  hide() {
    this.dependencies.$mdDialog.cancel();
  }
}



// WEBPACK FOOTER //
// ./user/developer-network/developer-network-ctrl.js